package devxertech.com.section

import androidx.compose.runtime.Composable
import androidx.compose.runtime.LaunchedEffect
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.rememberCoroutineScope
import androidx.compose.runtime.setValue
import com.varabyte.kobweb.compose.css.AlignItems
import com.varabyte.kobweb.compose.css.Cursor
import com.varabyte.kobweb.compose.css.TextTransform
import com.varabyte.kobweb.compose.css.Transition
import com.varabyte.kobweb.compose.css.TransitionProperty
import com.varabyte.kobweb.compose.foundation.layout.Arrangement
import com.varabyte.kobweb.compose.foundation.layout.Box
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.foundation.layout.Row
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.attrsModifier
import com.varabyte.kobweb.compose.ui.graphics.Colors
import com.varabyte.kobweb.compose.ui.modifiers.alignItems
import com.varabyte.kobweb.compose.ui.modifiers.backgroundColor
import com.varabyte.kobweb.compose.ui.modifiers.borderRadius
import com.varabyte.kobweb.compose.ui.modifiers.bottom
import com.varabyte.kobweb.compose.ui.modifiers.boxShadow
import com.varabyte.kobweb.compose.ui.modifiers.color
import com.varabyte.kobweb.compose.ui.modifiers.cursor
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxSize
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxWidth
import com.varabyte.kobweb.compose.ui.modifiers.fontFamily
import com.varabyte.kobweb.compose.ui.modifiers.fontSize
import com.varabyte.kobweb.compose.ui.modifiers.fontWeight
import com.varabyte.kobweb.compose.ui.modifiers.gap
import com.varabyte.kobweb.compose.ui.modifiers.height
import com.varabyte.kobweb.compose.ui.modifiers.left
import com.varabyte.kobweb.compose.ui.modifiers.margin
import com.varabyte.kobweb.compose.ui.modifiers.onClick
import com.varabyte.kobweb.compose.ui.modifiers.onMouseEnter
import com.varabyte.kobweb.compose.ui.modifiers.onMouseLeave
import com.varabyte.kobweb.compose.ui.modifiers.padding
import com.varabyte.kobweb.compose.ui.modifiers.position
import com.varabyte.kobweb.compose.ui.modifiers.right
import com.varabyte.kobweb.compose.ui.modifiers.scale
import com.varabyte.kobweb.compose.ui.modifiers.size
import com.varabyte.kobweb.compose.ui.modifiers.textTransform
import com.varabyte.kobweb.compose.ui.modifiers.top
import com.varabyte.kobweb.compose.ui.modifiers.transform
import com.varabyte.kobweb.compose.ui.modifiers.transition
import com.varabyte.kobweb.compose.ui.modifiers.width
import com.varabyte.kobweb.compose.ui.modifiers.zIndex
import com.varabyte.kobweb.compose.ui.styleModifier
import com.varabyte.kobweb.core.rememberPageContext
import com.varabyte.kobweb.silk.components.graphics.Image
import com.varabyte.kobweb.silk.components.icons.fa.FaPhone
import com.varabyte.kobweb.silk.components.icons.fa.IconSize
import com.varabyte.kobweb.silk.components.text.SpanText
import com.varabyte.kobweb.silk.style.breakpoint.Breakpoint
import com.varabyte.kobweb.silk.theme.colors.ColorMode
import devxertech.com.component.FieldTitleTextNormalSimple
import devxertech.com.component.MenuDropdown
import devxertech.com.models.MenuModel
import devxertech.com.theme.toSitePalette
import devxertech.com.utils.Constants
import devxertech.com.utils.Res
import kotlinx.browser.window
import kotlinx.coroutines.launch
import org.jetbrains.compose.web.css.Position
import org.jetbrains.compose.web.css.ms
import org.jetbrains.compose.web.css.percent
import org.jetbrains.compose.web.css.px

@Composable
fun HeaderTopBar(
    breakpoint: Breakpoint,
    onMenuClick: () -> Unit,
    isSpaceAround: Boolean = false,
    isServiceHeader: Boolean = false,
    contactModification: Boolean = false,
    careerPageShadow: Boolean = false,
    alwaysHovered: Boolean = false,
) {
    val scope = rememberCoroutineScope()
    val sitePalette = ColorMode.current.toSitePalette()
    var isHovered by remember { mutableStateOf(false) }
    var isButtonHovered by remember { mutableStateOf(false) }
    var isScrolled by remember { mutableStateOf(false) }
    val ctx = rememberPageContext()
    var isHomeHovered by remember { mutableStateOf(false) }
    var isPortfolioHovered by remember { mutableStateOf(false) }
    var isCareerHovered by remember { mutableStateOf(false) }
    var isBlogHovered by remember { mutableStateOf(false) }
    var isSolutionsHovered by remember { mutableStateOf(false) }
    var isPhoneHovered by remember { mutableStateOf(false) }

    LaunchedEffect(key1 = Unit) {
        window.onscroll = {
            scope.launch { isScrolled = window.scrollY > 0 }
        }
    }

    val fontModifier = Modifier.fontFamily(Constants.Top_Menu_Family)
        .fontSize(if (breakpoint == Breakpoint.LG || window.screen.width in 1240..1600) 15.px else 18.px)
        .fontWeight(500)
        .color(if (isHovered || !isScrolled) Colors.White else sitePalette.topBarMenuText.rgb)
        .cursor(Cursor.Pointer)
        .textTransform(TextTransform.Uppercase)

    val lineUnderTitle = 4.px

    Box(
        modifier = Modifier.fillMaxWidth()
            .backgroundColor(if (isHovered || isScrolled) Colors.White else Colors.Transparent)
            .transition(Transition.of("background-color", 500.ms))
            .position(Position.Fixed)
            .padding(top = 20.px, bottom = 10.px)
            .zIndex(4)
            .then(
                if (careerPageShadow) {
                    Modifier.boxShadow(
                        offsetX = 0.px,
                        offsetY = 4.px,
                        blurRadius = 7.6.px,
                        spreadRadius = 0.px,
                        color = sitePalette.specialButtonBorderColor.rgb
                    )
                } else {
                    Modifier
                }
            )
    ) {
        Row(
            modifier = Modifier.fillMaxWidth(if (contactModification && breakpoint == Breakpoint.LG) 1024.px else 100.percent)
                .padding(leftRight = if (window.screen.width < 375) 15.px else 30.px),
            verticalAlignment = Alignment.CenterVertically,
            horizontalArrangement = if (breakpoint <= Breakpoint.XL) Arrangement.SpaceBetween else Arrangement.SpaceEvenly
        ) {
            Box(
                modifier = Modifier.width(
                    when {
                        isServiceHeader && breakpoint == Breakpoint.LG -> 220.px
                        window.screen.width in 1024..1439 -> 250.px
                        window.screen.width == 1440 -> 420.px
                        window.screen.width > 1750 -> 35.percent
                        else -> 550.px
                    }
                )
            ) {
                DesktopNavigationAnchor("/", Modifier.attrsModifier { attr("aria-label", "DevxerTech home") }) {
Image(
                    src = if (isHovered || isScrolled) Res.Image.colored_logo else if (alwaysHovered) Res.Image.colored_logo else Res.Image.white_Logo,
                    modifier = Modifier.width(
                        if (isServiceHeader && breakpoint == Breakpoint.LG) 190.px else 213.px
                    )
                        .height(
                            if (isServiceHeader && breakpoint == Breakpoint.LG) 40.px else 40.px
                        )
                        .margin(left = if (isSpaceAround) 10.px else 0.px, top = 6.px)
                        
                        .cursor(Cursor.Pointer)
                )
                }
            }

            if (breakpoint >= Breakpoint.XL) {
                Column(
                    modifier = Modifier
                        .onMouseEnter { isHomeHovered = true }
                        .onMouseLeave { isHomeHovered = false }
                        .alignItems(AlignItems.Center)
                ) {
                    DesktopNavigationLink("/", "Home", fontModifier)
                    Box(
                        modifier = Modifier
                            .height(lineUnderTitle)
                            .width(if (isHomeHovered) 42.px else 0.px)
                            .backgroundColor(if (isHovered || !isScrolled) sitePalette.bodyBackgroundSecondary.rgb else sitePalette.primary.rgb)
                            .transition(Transition.of(TransitionProperty.All, 300.ms))
                            .scale(1.0)
                    )
                }
                Box {
                    MenuDropdown(
                        title = "Services",
                        data = listOfNotNull(
                            MenuModel(text = "Web Development", route = "/web-services"),
                            MenuModel(text = "Mobile App Development", route = "/mobile-services"),
                            MenuModel(text = "Dev Ops", route = "/dev-operation"),
                            MenuModel(text = "UI/UX Design", route = "/ui-services"),
                            MenuModel(text = "AI Development", route = "/ai-services"),
                            MenuModel(text = "Chatbot Development", route = "/chatbot-development")
                        ),
                        textSpanColor = if (isHovered || !isScrolled) Colors.White else sitePalette.topBarMenuText.rgb,
                        underlineColor = (if (isHovered || !isScrolled) sitePalette.bodyBackgroundSecondary.rgb else sitePalette.primary.rgb),
                        crawlableItems = true,
                        onSelect = { ctx.router.navigateTo(it.route) }
                    )
                }
                Column(
                    modifier = Modifier
                        .onMouseEnter { isSolutionsHovered = true }
                        .onMouseLeave { isSolutionsHovered = false }
                        .alignItems(AlignItems.Center)
                ) {
                    DesktopNavigationLink("/solutions", "Solutions", fontModifier)
                    Box(
                        modifier = Modifier
                            .height(lineUnderTitle)
                            .width(if (isSolutionsHovered) 60.px else 0.px)
                            .backgroundColor(if (isHovered || !isScrolled) sitePalette.bodyBackgroundSecondary.rgb else sitePalette.primary.rgb)
                            .transition(Transition.of(TransitionProperty.All, 300.ms))
                            .scale(1.0)
                    )
                }
                Box {
                    MenuDropdown(
                        title = "Industries",
                        data = listOfNotNull(
                            MenuModel(text = "HealthCare Industry", route = "/healthcare-system"),
                            MenuModel(text = "Fintech Industry", route = "/fintech-Industry"),
                            MenuModel(text = "Sports Industry", route = "/sports-industry"),
                            MenuModel(text = "Edu Industry", route = "/industry-edu"),
                        ),
                        textSpanColor = if (isHovered || !isScrolled) Colors.White else sitePalette.topBarMenuText.rgb,
                        underlineColor = (if (isHovered || !isScrolled) sitePalette.bodyBackgroundSecondary.rgb else sitePalette.primary.rgb),
                        crawlableItems = true,
                        onSelect = { ctx.router.navigateTo(it.route) }

                    )
                }
//
//                SpanText("Dedicated Developers", modifier = fontModifier)
                Column(
                    modifier = Modifier
                        .onMouseEnter { isPortfolioHovered = true }
                        .onMouseLeave { isPortfolioHovered = false }
                        .alignItems(AlignItems.Center)
                ) {
                    DesktopNavigationLink("/portfolio", "Portfolio", fontModifier)
                    Box(
                        modifier = Modifier
                            .height(lineUnderTitle)
                            .width(if (isPortfolioHovered) 60.px else 0.px)
                            .backgroundColor(if (isHovered || !isScrolled) sitePalette.bodyBackgroundSecondary.rgb else sitePalette.primary.rgb)
                            .transition(Transition.of(TransitionProperty.All, 300.ms))
                            .scale(1.0)
                    )
                }
                Column(
                    modifier = Modifier
                        .onMouseEnter { isCareerHovered = true }
                        .onMouseLeave { isCareerHovered = false }
                        .alignItems(AlignItems.Center)
                ) {
                    DesktopNavigationLink("/career-page", "Career", fontModifier)
                    Box(
                        modifier = Modifier
                            .height(lineUnderTitle)
                            .width(if (isCareerHovered) 60.px else 0.px)
                            .backgroundColor(if (isHovered || !isScrolled) sitePalette.bodyBackgroundSecondary.rgb else sitePalette.primary.rgb)
                            .transition(Transition.of(TransitionProperty.All, 300.ms))
                            .scale(1.0)
                    )
                }
                Column(
                    modifier = Modifier
                        .onMouseEnter { isBlogHovered = true }
                        .onMouseLeave { isBlogHovered = false }
                        .alignItems(AlignItems.Center)
                ) {
                    DesktopNavigationLink("/blogs", "Blogs", fontModifier)
                    Box(
                        modifier = Modifier
                            .height(lineUnderTitle)
                            .width(if (isBlogHovered) 50.px else 0.px)
                            .backgroundColor(if (isHovered || !isScrolled) sitePalette.bodyBackgroundSecondary.rgb else sitePalette.primary.rgb)
                            .transition(Transition.of(TransitionProperty.All, 300.ms))
                            .scale(1.0)
                    )
                }

                Row(
                    modifier = Modifier.gap(6.px),
                    verticalAlignment = Alignment.CenterVertically,
                    horizontalArrangement = Arrangement.Center
                ) {
                    FaPhone(
                        modifier = Modifier.color(if (isButtonHovered || !isScrolled) Colors.White else sitePalette.topBarMenuText.rgb)
                            .margin(bottom = if (window.screen.width in 1400..1900) 4.px else 2.px),
                        size = IconSize.SM
                    )
                    Column(
                        modifier = Modifier
                            .onMouseEnter { isPhoneHovered = true }
                            .onMouseLeave { isPhoneHovered = false }
                            .alignItems(AlignItems.Center)
                    ) {
                        FieldTitleTextNormalSimple(
                            text = "+92-3057418989",
                            fontFamily = Constants.Top_Menu_Family,
                            fontSize = if (breakpoint == Breakpoint.LG || window.screen.width in 1240..1600) 15.px else 18.px,
                            fontWeight = 500,
                            color = if (isButtonHovered || !isScrolled) Colors.White else sitePalette.topBarMenuText.rgb
                        )
                        Box(
                            modifier = Modifier
                                .height(lineUnderTitle)
                                .width(if (isPhoneHovered) 100.px else 0.px)
                                .backgroundColor(if (isHovered || !isScrolled) sitePalette.bodyBackgroundSecondary.rgb else sitePalette.primary.rgb)
                                .transition(Transition.of(TransitionProperty.All, 300.ms))
                                .scale(1.0)
                        )
                    }
                }

                Box(
                    modifier = Modifier,
                    contentAlignment = Alignment.Center
                ) {
                    Row(
                        modifier = Modifier,
                        verticalAlignment = Alignment.CenterVertically,
                        horizontalArrangement = Arrangement.SpaceEvenly
                    ) {
//                        UpdatedButton(text = "Contact Us", onClick = {ctx.router.navigateTo("/contact-us") })
                        DesktopNavigationAnchor(
                            path = "/contact-us",
                            modifier = Modifier
                                .width(if (breakpoint == Breakpoint.LG || window.screen.width in 1240..1600) 140.px else 160.px)
                                .height(40.px)
                                
                                .cursor(Cursor.Pointer)
                                .onMouseEnter { isButtonHovered = true }
                                .onMouseLeave { isButtonHovered = false }
                                .borderRadius(6.px)
                                .position(Position.Relative)
                                .backgroundColor(
                                    if (!isScrolled) Colors.White
                                    else sitePalette.commonSecondaryButtonColor.rgb
                                )
                                .styleModifier {
                                    property("display", "flex")
                                    property("align-items", "center")
                                    property("justify-content", "center")
                                    property("font-size", "17px")
                                }
                        ) {
                            // Overlay Box like ::before
                            Box(
                                modifier = Modifier
                                    .fillMaxSize()
                                    .borderRadius(6.px)
//                                    .width(if (breakpoint == Breakpoint.LG || window.screen.width in 1240..1600) 140.px else 170.5.px)
                                    .height(42.5.px)
                                    .position(Position.Absolute)
                                    .backgroundColor(
                                        if (isButtonHovered && !isScrolled) sitePalette.primary.rgb
                                        else if (isScrolled) sitePalette.primary.rgb else sitePalette.commonSecondaryButtonColor.rgb
                                    )
                                    .top(0.px)
                                    .left(0.px)
                                    .zIndex(0)
                                    .styleModifier {
                                        property("will-change", "clip-path")
                                        property(
                                            "transition",
                                            "clip-path 0.2s ease-in-out, opacity 0.1s ease-in-out"
                                        )
                                        property("opacity", if (isButtonHovered) "1" else "0.999")
                                        property(
                                            "clip-path",
                                            if (isButtonHovered)
                                                "polygon(0% 100%, 0% 0%, 100% 0%, 100% 100%)"
                                            else
                                                "polygon(98% 98%, 99% 98%, 99% 99%, 98% 99%)"
                                        )
                                    }
                            )
                            Box(
                                modifier = Modifier
                                    .size(12.px)
                                    .backgroundColor(sitePalette.primary.rgb)
                                    .position(Position.Absolute)
                                    .bottom(0.px)
                                    .right(0.px)
                                    .borderRadius(2.px)
                                    .transform {
                                        translateX(5.5.px)
                                        translateY(5.px)
                                    }
                                    .zIndex(10)
                                    .styleModifier {
                                        property("opacity", if (isButtonHovered) "0" else "1")
                                        property("transition", "opacity 0.1s ease")
                                        property(
                                            "pointer-events",
                                            if (isButtonHovered) "none" else "auto"
                                        )
                                    }
                            )
                            SpanText(
                                text = "Contact Us",
                                modifier = Modifier
                                    .fontFamily(Constants.FONT_FAMILY)
                                    .fontSize(if (breakpoint == Breakpoint.LG || window.screen.width in 1240..1600) 16.px else 18.px)
                                    .fontWeight(500)
                                    .textTransform(TextTransform.Uppercase)
                                    .color(if (isScrolled || isButtonHovered) Colors.White else sitePalette.commonSecondaryButtonColor.rgb)
                                    .zIndex(1)
                            )
                        }
                    }
                }
            } else {
                CustomFaBarsfoHeader(
                    isScrolled = isScrolled,
                    alwaysHovered = alwaysHovered,
                    onMenuClick = onMenuClick
                )
//                FaBars(
//                    modifier = Modifier.margin(bottom = 12.px).color(
//                        if (isScrolled) sitePalette.textFieldTextColor.rgb else if (alwaysHovered) sitePalette.textFieldTextColor.rgb else sitePalette.bodyBackgroundSecondary.rgb
//                    )
//                        .onClick { onMenuClick() },
//                    size = IconSize.XL
//                )
            }
        }
    }
}


@Composable
fun CustomFaBarsfoHeader(
    isScrolled: Boolean,
    alwaysHovered: Boolean,
    onMenuClick: () -> Unit,
    // You already have this in your code
) {
    val sitePalette = ColorMode.current.toSitePalette()
    // Determine icon color based on scroll/hover state
    val barColor = if (isScrolled || alwaysHovered) {
        sitePalette.commonSecondaryButtonColor.rgb
    } else {
        sitePalette.bodyBackgroundSecondary.rgb
    }

    Column(
        modifier = Modifier
            .margin(bottom = 12.px)
            .onClick { onMenuClick() }
            .cursor(Cursor.Pointer),
        verticalArrangement = Arrangement.spacedBy(6.px),
        horizontalAlignment = Alignment.End
    ) {
        // Top bar
        Box(
            Modifier
                .width(30.px) // XL width
                .height(4.px)
                .backgroundColor(barColor)
                .borderRadius(2.px)
        )
        // Middle bar (slightly shorter, indented)
        Box(
            Modifier
                .padding(left = 6.px)
                .width(22.px)
                .height(4.px)
                .backgroundColor(barColor)
                .borderRadius(2.px)
        )
        // Bottom bar (shortest, more indented)
        Box(
            Modifier
                .padding(left = 12.px)
                .width(14.px)
                .height(4.px)
                .backgroundColor(barColor)
                .borderRadius(2.px)
        )
    }
}
